/**
 * Full-page navigation seam. Sign-in flows must leave the SPA entirely — the
 * server sets the session cookie on a redirect — and jsdom cannot perform real
 * navigation, so this indirection exists to be stubbed in tests.
 */
export const browserNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  },
};
